namespace RedBullMOBILE360.SMSCodes {
    export interface InformativeSmsForm {
        Code: Serenity.StringEditor;
        MessageEn: Serenity.TextAreaEditor;
        MessageAr: Serenity.TextAreaEditor;
    }

    export class InformativeSmsForm extends Serenity.PrefixedContext {
        static formKey = 'SMSCodes.InformativeSms';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InformativeSmsForm.init)  {
                InformativeSmsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(InformativeSmsForm, [
                    'Code', w0,
                    'MessageEn', w1,
                    'MessageAr', w1
                ]);
            }
        }
    }
}
